import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';

import config from '../../config';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { REVIEW_TYPE_OF_PROVIDER, REVIEW_TYPE_OF_CUSTOMER, propTypes } from '../../util/types';
import { ensureCurrentUser, ensureUser } from '../../util/data';
import { withViewport } from '../../util/contextHelpers';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { getListingsById, getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  AvatarLarge,
  NamedLink,
  ListingCard,
  Reviews,
  ButtonTabNavHorizontal,
  ReviewRating,
  SoldCard,
  ListSkeleton,
  AuthorSkeleton,
  RippleSpinner,
} from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
import { withRouter } from 'react-router-dom';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import routeConfiguration from '../../routing/routeConfiguration';
import { createResourceLocatorString } from '../../util/routes';
import { TUTULIST } from '../../util/enums';
import css from './ProfilePage.module.css';
import { setLoadData } from './ProfilePage.duck';
import {
  capitalizeFirstLetter,
  getBookmarks,
  getLastActivity,
  getStoreName,
  getUsername,
  getWishlist,
  isArrayLength,
  isTutuList,
  isZeroStock,
} from '../../util/dataExtractors';
import moment from 'moment';
import IconSoldTag from '../../components/IconSoldTag/IconSoldTag';
import IconFlashLight from '../../components/IconFlashLight/IconFlashLight';
// import IconBag from '../../components/IconBag/IconBag';
import IconLargeGrid from '../../components/IconLargeGrid/IconLargeGrid';
import IconSmallGrid from '../../components/IconSmallGrid/IconSmallGrid';
import { updateSave } from '../../ducks/user.duck';
import { types as sdkTypes } from '../../util/sdkLoader';
import QuickFilters from './QuickFilters/QuickFilters';
import { quickFilters } from '../../config/marketplace-custom-config';
import { getFilteredListings } from '../../util/profileHelpers';

const MAX_MOBILE_SCREEN_WIDTH = 768;

const SELLING = 'selling';
const SOLD = 'sold';
const LIKES = 'likes';
const REVIEWS = 'reviews';

const tabs = [SELLING, SOLD, LIKES, REVIEWS];
const { UUID } = sdkTypes;
export class ProfilePageComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // keep track of which reviews tab to show in desktop viewport
      showReviewsType: REVIEW_TYPE_OF_PROVIDER,
      currentTab: SELLING,
      bookmarks:
        props.currentUser &&
        props.currentUser.attributes &&
        props.currentUser.attributes.profile &&
        props.currentUser.attributes.profile.publicData &&
        props.currentUser.attributes.profile.publicData.bookmarks
          ? props.currentUser.attributes.profile.publicData.bookmarks
          : [],
      wishlist:
        props.currentUser &&
        props.currentUser.attributes &&
        props.currentUser.attributes.profile &&
        props.currentUser.attributes.profile.publicData &&
        props.currentUser.attributes.profile.publicData.wishlist
          ? props.currentUser.attributes.profile.publicData.wishlist
          : [],
      active: false,
      activeTab: 0,
      showSkeleton: true,
      filter: null,
      activeFilter: -1,
    };
    this.showOfProviderReviews = this.showOfProviderReviews.bind(this);
    this.showOfCustomerReviews = this.showOfCustomerReviews.bind(this);
    this.handleWishlist = this.handleWishlist.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.onSwitchTabs = this.onSwitchTabs.bind(this);
    this.toggleClass = this.toggleClass.bind(this);
    this.onFilter = this.onFilter.bind(this);
  }

  componentDidMount() {
    const { location, onSetLoadData, params } = this.props;
    const username = params && params.username;
    const userId = location && location.state;
    // setTimeout(() => this.setState({ showSkeleton: false }), 2000);
    onSetLoadData(userId, username);
  }

  toggleClass() {
    this.setState({ addClass: !this.state.addClass });
  }

  onFilter(filter, index) {
    this.setState({ filter, activeFilter: index });
  }

  onSwitchTabs(tab) {
    this.setState({
      currentTab: tab,
    });
  }

  handleWishlist(id, e) {
    const { onUpdateProfile, currentUser, isAuthenticated } = this.props;

    e.preventDefault();
    e.stopPropagation();

    if (!isAuthenticated && e && id) {
      let localBookmarks =
        typeof window !== 'undefined' &&
        window.localStorage.getItem('localBookmarks') &&
        window.localStorage.getItem('localBookmarks').length > 0
          ? window.localStorage.getItem('localBookmarks')
          : [];

      if (typeof localBookmarks === 'string') {
        localBookmarks =
          typeof window !== 'undefined' &&
          JSON.parse(window.localStorage.getItem('localBookmarks'));
      }

      const localIndex = localBookmarks && localBookmarks.findIndex(b => b == id);

      if (localIndex > -1) {
        localBookmarks && localBookmarks.splice(localIndex, 1);
        const removedBookmarks = Array.from(new Set(localBookmarks));
        typeof window !== 'undefined' &&
          window.localStorage.setItem('localBookmarks', JSON.stringify(removedBookmarks));
      } else {
        localBookmarks.push(id);
        const addedBookmarks = Array.from(new Set(localBookmarks));
        typeof window !== 'undefined' &&
          window.localStorage.setItem('localBookmarks', JSON.stringify(addedBookmarks));
      }
    } else {
      const bookmarks = getBookmarks(currentUser);

      const index = bookmarks && bookmarks.findIndex(b => b == id);

      if (id) {
        if (index > -1) {
          bookmarks && bookmarks.splice(index, 1);
          const removedBookmarks = Array.from(new Set(bookmarks));
          const profile = {
            publicData: {
              bookmarks: removedBookmarks,
            },
          };
          onUpdateProfile(profile);
        } else {
          this.state.bookmarks.push(id);
          const addedBookmarks = Array.from(new Set(this.state.bookmarks));
          const profile = {
            publicData: {
              bookmarks: addedBookmarks,
            },
          };
          onUpdateProfile(profile);
        }
      }
    }
  }

  showOfProviderReviews() {
    this.setState({
      showReviewsType: REVIEW_TYPE_OF_PROVIDER,
    });
  }

  showOfCustomerReviews() {
    this.setState({
      showReviewsType: REVIEW_TYPE_OF_CUSTOMER,
    });
  }

  handleSave(params) {
    const { id, e, likes } = params;
    const { onUpdateProfile, currentUser, isAuthenticated, history, onUpdateSave } = this.props;

    e.preventDefault();
    e.stopPropagation();

    if (!isAuthenticated && e && id) {
      const routes = routeConfiguration();
      history.push(createResourceLocatorString('LoginPage', routes, {}, {}));
    } else {
      const wishlist = getWishlist(currentUser);

      const index = wishlist && wishlist.findIndex(b => b == id);
      const likesIndex = Array.isArray(likes) && likes.findIndex(l => l == currentUser?.id?.uuid);

      if (id) {
        // To save in listing to show likes
        if (likesIndex > -1) {
          likes && likes.splice(likesIndex, 1);
          const filteredLikes = Array.from(new Set(likes));
          onUpdateSave({ likes: filteredLikes, listingId: id });
        } else {
          Array.isArray(likes) && likes.push(currentUser?.id?.uuid);
          const filteredLikes = Array.from(new Set(likes));
          onUpdateSave({ likes: filteredLikes, listingId: id });
        }

        // To save in currentUser as favourites
        if (index > -1) {
          wishlist && wishlist.splice(index, 1);
          const removedwishlist = Array.from(new Set(wishlist));
          const profile = {
            publicData: {
              wishlist: removedwishlist,
            },
          };
          onUpdateProfile(profile);
        } else {
          this.state.wishlist.push(id);
          const addedwishlist = Array.from(new Set(this.state.wishlist));
          const profile = {
            publicData: {
              wishlist: addedwishlist,
            },
          };
          onUpdateProfile(profile);
        }
      }
    }
  }

  render() {
    const {
      scrollingDisabled,
      currentUser,
      user,
      userShowError,
      queryListingsError,
      reviews,
      queryReviewsError,
      viewport,
      intl,
      soldItems,
      likes,
      queryInProgress,
      soldListings,
      fetchingSoldInProgress,
      isAuthenticated,
      onUpdateProfile,
      params,
    } = this.props;

    let { listings } = this.props;
    const username = params && params.username;
    const ensuredCurrentUser = ensureCurrentUser(currentUser);
    const profileUser = ensureUser(user);

    const bookmarks =
      currentUser &&
      currentUser.attributes &&
      currentUser.attributes.profile &&
      currentUser.attributes.profile.publicData &&
      currentUser.attributes.profile.publicData.bookmarks;

    const lb =
      typeof window !== 'undefined' &&
      typeof window.localStorage.getItem('localBookmarks') === 'string' &&
      JSON.parse(window.localStorage.getItem('localBookmarks'));

    // const isCurrentUser =
    //   ensuredCurrentUser.id && profileUser.id && ensuredCurrentUser.id.uuid === profileUser.id.uuid;
    const displayName = profileUser.attributes.profile.displayName;
    const bio = profileUser.attributes.profile.bio;
    const hasBio = !!bio;
    // const hasListings = listings.length > 0;
    const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;
    const isAdmin = isTutuList(displayName);
    // const editLinkMobile = isCurrentUser ? (
    //   <NamedLink className={css.editLinkMobile} name="ProfileSettingsPage">
    //     <FormattedMessage id="ProfilePage.editProfileLinkMobile" />
    //   </NamedLink>
    // ) : null;
    // const editLinkDesktop = isCurrentUser ? (
    //   <NamedLink className={css.editLinkDesktop} name="ProfileSettingsPage">
    //     <FormattedMessage id="ProfilePage.editProfileLinkDesktop" />
    //   </NamedLink>
    // ) : null;

    // const asideContent = (
    //   <div className={css.asideContent}>
    //     <AvatarLarge className={css.avatar} user={user} disableProfileLink />
    //     <h1 className={css.mobileHeading}>
    //       {displayName ? (
    //         <FormattedMessage id="ProfilePage.mobileHeading" values={{ name: displayName }} />
    //       ) : null}
    //     </h1>
    //     {editLinkMobile}
    //     {editLinkDesktop}
    //   </div>
    // );

    // const listingsContainerClasses = classNames(css.listingsContainer, {
    //   [css.withBioMissingAbove]: !hasBio,
    // });

    // const reviewsError = (
    //   <p className={css.error}>
    //     <FormattedMessage id="ProfilePage.loadingReviewsFailed" />
    //   </p>
    // );

    const reviewsOfProvider =
      reviews &&
      reviews
        .filter(r => r.attributes.type === REVIEW_TYPE_OF_PROVIDER)
        .filter(item => item?.id?.uuid !== '6330e613-ef7a-4657-99ef-fcb48fc3f42c');

    // const reviewsOfCustomer = reviews.filter(r => r.attributes.type === REVIEW_TYPE_OF_CUSTOMER);

    // const mobileReviews = (
    //   <div className={css.mobileReviews}>
    //     <h2 className={css.mobileReviewsTitle}>
    //       <FormattedMessage
    //         id="ProfilePage.reviewsOfProviderTitle"
    //         values={{ count: reviewsOfProvider.length }}
    //       />
    //     </h2>
    //     {queryReviewsError ? reviewsError : null}
    //     <Reviews reviews={reviewsOfProvider} />
    //     <h2 className={css.mobileReviewsTitle}>
    //       <FormattedMessage
    //         id="ProfilePage.reviewsOfCustomerTitle"
    //         values={{ count: reviewsOfCustomer.length }}
    //       />
    //     </h2>
    //     {queryReviewsError ? reviewsError : null}
    //     <Reviews reviews={reviewsOfCustomer} />
    //   </div>
    // );

    // const desktopReviewTabs = [
    //   {
    //     text: (
    //       <h3 className={css.desktopReviewsTitle}>
    //         <FormattedMessage
    //           id="ProfilePage.reviewsOfProviderTitle"
    //           values={{ count: reviewsOfProvider.length }}
    //         />
    //       </h3>
    //     ),
    //     selected: this.state.showReviewsType === REVIEW_TYPE_OF_PROVIDER,
    //     onClick: this.showOfProviderReviews,
    //   },
    //   // {
    //   //   text: (
    //   //     <h3 className={css.desktopReviewsTitle}>
    //   //       <FormattedMessage
    //   //         id="ProfilePage.reviewsOfCustomerTitle"
    //   //         values={{ count: reviewsOfCustomer.length }}
    //   //       />
    //   //     </h3>
    //   //   ),
    //   //   selected: this.state.showReviewsType === REVIEW_TYPE_OF_CUSTOMER,
    //   //   onClick: this.showOfCustomerReviews,
    //   // },
    // ];

    // const desktopReviews = (
    //   <div className={css.desktopReviews}>
    //     <div className={css.desktopReviewsWrapper}>
    //       <ButtonTabNavHorizontal className={css.desktopReviewsTabNav} tabs={desktopReviewTabs} />

    //       {queryReviewsError ? reviewsError : null}

    //       {this.state.showReviewsType === REVIEW_TYPE_OF_PROVIDER ? (
    //         <Reviews reviews={reviewsOfProvider} />
    //       ) : (
    //         <Reviews reviews={reviewsOfCustomer} />
    //       )}
    //     </div>
    //   </div>
    // );

    const wishlist =
      currentUser &&
      currentUser.attributes &&
      currentUser.attributes.profile &&
      currentUser.attributes.profile.publicData &&
      currentUser.attributes.profile.publicData.wishlist;

    const averageReviewCount =
      Array.isArray(reviewsOfProvider) &&
      reviewsOfProvider
        .map(item => item.attributes.rating)
        .reduce((partialSum, a) => partialSum + a, 0) / reviewsOfProvider?.length;

    const lastActivity =
      profileUser &&
      profileUser.id &&
      moment(getLastActivity(profileUser)).calendar(null, {
        sameDay: '[Today]',
        nextDay: '[Today]',
        nextWeek: 'dddd',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'DD/MM/YYYY',
      });

    const userName = getUsername(profileUser);

    if (this.state.filter) {
      listings = getFilteredListings(this.state.filter, listings);
    }
    const tabnav = (
      <div className={css.tabs}>
        {tabs.map((item, index) => (
          <span
            key={index}
            className={classNames(css.tab, this.state.activeTab === index ? css.active : null)}
            onClick={() => {
              this.onSwitchTabs(item), this.setState({ activeTab: index });
            }}
          >
            {capitalizeFirstLetter(item)}
          </span>
        ))}
      </div>
    );

    const tabContent = () => {
      switch (this.state.currentTab) {
        case SELLING:
          return (
            <div
              className={classNames(
                css.tabContentSellingWrapper,
                this.state.addClass ? css.changeView : null
              )}
            >
              {isArrayLength(listings) &&
                listings.map(l => (
                  <span className={css.listing} key={l?.id?.uuid}>
                    <ListingCard
                      listing={l}
                      showAuthorInfo={true}
                      isProfile={true}
                      bookmarks={lb || bookmarks}
                      handleWishlist={this.handleWishlist}
                      handleSave={this.handleSave}
                      wishlist={wishlist}
                      isAuthenticated={isAuthenticated}
                      onUpdateProfile={onUpdateProfile}
                      currentUser={ensuredCurrentUser}
                      disableProfileLink={true}
                    />
                  </span>
                ))}
            </div>
          );
        case SOLD:
          return (
            <div
              className={classNames(
                css.tabContentWrapper,
                this.state.addClass ? css.changeView : null
              )}
            >
              {isArrayLength(soldListings) &&
                soldListings?.map(l => (
                  <span className={css.listing} key={l.id.uuid}>
                    <SoldCard listing={l} />
                  </span>
                ))}
            </div>
          );
        case LIKES:
          return (
            <div
              className={classNames(
                css.tabContentSellingWrapper,
                this.state.addClass ? css.changeView : null
              )}
            >
              {isArrayLength(likes) &&
                likes.map(l => (
                  <span className={css.listing} key={l?.id?.uuid}>
                    <ListingCard
                      listing={l}
                      showAuthorInfo={true}
                      isProfile={true}
                      bookmarks={lb || bookmarks}
                      handleWishlist={this.handleWishlist}
                      handleSave={this.handleSave}
                      wishlist={wishlist}
                      isAuthenticated={isAuthenticated}
                      onUpdateProfile={onUpdateProfile}
                      currentUser={ensuredCurrentUser}
                      disableProfileLink={true}
                    />
                  </span>
                ))}
            </div>
          );
        case REVIEWS:
          return <Reviews reviews={reviewsOfProvider} />;
        default:
          return false;
      }
    };

    const mainContent = (
      <div className={css.profileContentWrapper}>
        {queryInProgress ? (
          <div className={css.headerContainer}>
            <AuthorSkeleton viewport={viewport} />
          </div>
        ) : (
          <div className={css.headerContainer}>
            <AvatarLarge className={css.avatar} user={user} disableProfileLink />
            <div className={css.userInfo}>
              <h1 className={css.desktopHeading}>{getStoreName(profileUser) || displayName}</h1>
              <p>{userName && `@${userName}`}</p>

              <div
                className={css.ratings}
                onClick={() => {
                  this.onSwitchTabs(REVIEWS), this.setState({ activeTab: 3 });
                }}
              >
                <ReviewRating
                  rating={averageReviewCount || 0}
                  className={css.desktopReviewRating}
                  reviewStarClassName={css.reviewRatingStar}
                />
                ({reviewsOfProvider?.length})
              </div>
              <div className={css.profilePerformance}>
                <span>
                  <IconSoldTag />
                  {fetchingSoldInProgress ? (
                    soldItems == '0' ? (
                      <FormattedMessage id="ProfilePage.soldItems" values={{ count: 0 }} />
                    ) : (
                      <RippleSpinner />
                    )
                  ) : (
                    <FormattedMessage
                      id="ProfilePage.soldItems"
                      values={{ count: isAdmin ? soldItems + 1256 : soldItems }}
                    />
                  )}
                </span>
                <span>
                  <IconFlashLight />
                  {lastActivity && (
                    <FormattedMessage id="ProfilePage.active" values={{ active: lastActivity }} />
                  )}
                </span>
              </div>
              {hasBio ? <p className={css.bio}>{bio}</p> : null}
            </div>
          </div>
        )}

        <div className={css.profileTabs}>
          {tabnav}
          {isMobileLayout ? null : (
            <div className={css.contentView} onClick={this.toggleClass}>
              {this.state.addClass ? <IconSmallGrid /> : <IconLargeGrid />}
            </div>
          )}
        </div>
        <div className={css.filters}>
          <QuickFilters
            viewport={viewport}
            filters={quickFilters}
            onFilter={this.onFilter}
            username={username || TUTULIST}
            author={profileUser}
          />
        </div>
        {queryInProgress ? <ListSkeleton viewport={viewport} /> : tabContent()}
      </div>
    );

    let content;

    if (userShowError && userShowError.status === 404) {
      return <NotFoundPage />;
    } else if (userShowError || queryListingsError) {
      content = (
        <p className={css.error}>
          <FormattedMessage id="ProfilePage.loadingDataFailed" />
        </p>
      );
    } else {
      content = mainContent;
    }

    const schemaTitle = intl.formatMessage(
      {
        id: 'ProfilePage.schemaTitle',
      },
      {
        name: getStoreName(profileUser) || displayName,
        siteTitle: config.siteTitle,
      }
    );

    const schemaDescription = intl.formatMessage(
      {
        id: 'ProfilePage.schemaDescription',
      },
      {
        name: getStoreName(profileUser) || displayName || '',
      }
    );

    return (
      <Page
        scrollingDisabled={scrollingDisabled}
        title={schemaTitle}
        description={schemaDescription}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'WebPage',
          name: schemaTitle,
        }}
      >
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="ProfilePage" lb={lb} />
        </LayoutWrapperTopbar>
        {/* <LayoutWrapperSideNav className={css.aside}>{asideContent}</LayoutWrapperSideNav> */}
        <LayoutWrapperMain>{content}</LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </Page>
    );
  }
}

ProfilePageComponent.defaultProps = {
  currentUser: null,
  user: null,
  userShowError: null,
  queryListingsError: null,
  reviews: [],
  queryReviewsError: null,
};

const { bool, arrayOf, number, shape } = PropTypes;

ProfilePageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  currentUser: propTypes.currentUser,
  user: propTypes.user,
  userShowError: propTypes.error,
  queryListingsError: propTypes.error,
  // listings: arrayOf(propTypes.listing).isRequired,
  reviews: arrayOf(propTypes.review),
  queryReviewsError: propTypes.error,

  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.Auth;
  const { currentUser } = state.user;
  const {
    userId,
    userShowError,
    queryListingsError,
    userListingRefs,
    reviews,
    queryReviewsError,
    customPageResultIds,
    soldItems,
    likes,
    queryInProgress,
    fetchingSoldInProgress,
    soldListings: soldListingsIds,
  } = state.ProfilePage;

  const userMatches = getMarketplaceEntities(state, [{ type: 'user', id: userId }]);

  const user = userMatches.length === 1 ? userMatches[0] : null;

  const allListings =
    customPageResultIds &&
    customPageResultIds.map(item => {
      return { id: item, type: 'listing' };
    });
  const likesListings = likes && likes.length && getListingsById(state, likes);
  const soldListings =
    Array.isArray(soldListingsIds) &&
    soldListingsIds.length &&
    getListingsById(state, soldListingsIds);
  const listings = allListings && getMarketplaceEntities(state, allListings);
  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    user,
    userShowError,
    queryListingsError,
    listings: listings && listings.filter(item => !isZeroStock(item)),
    reviews,
    queryReviewsError,
    soldItems,
    likes: likesListings,
    queryInProgress,
    soldListings,
    fetchingSoldInProgress,
    isAuthenticated,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
  onSetLoadData: (userId, username) => dispatch(setLoadData(userId, username)),
  onUpdateSave: data => dispatch(updateSave(data)),
});

const ProfilePage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withViewport,
  injectIntl
)(ProfilePageComponent);

export default ProfilePage;
